//@ts-ignore
import { useRef, useState, ReactNode, SyntheticEvent } from 'react';
import { useNavigate } from 'react-router';

// material-ui
import { useTheme } from '@mui/material/styles';
//@ts-ignore
import {
  Box,
  ButtonBase,
  CardContent,
  ClickAwayListener,
  Divider,
  Grid,
  Paper,
  Popper,
  Stack,
  // Tab,
  // Tabs,
  Tooltip,
  Typography
} from '@mui/material';

// project-imports
import ProfileTab from './ProfileTab';
// import SettingTab from './SettingTab';
import Avatar from 'components/@extended/Avatar';
import MainCard from 'components/MainCard';
import Transitions from 'components/@extended/Transitions';
import IconButton from 'components/@extended/IconButton';
import useAuth from 'hooks/useAuth';

// assets
import avatar1 from 'assets/images/common/default_profile_icon.png';
//@ts-ignore
import { Setting2, Profile, Logout } from 'iconsax-react';

// types
import { ThemeMode } from 'types/config';
import LogoutConfirmationModal from 'components/alert/LogoutConfirmation';
import ChangePasswordModal from 'components/alert/ChangePasswordModal';
import WebSocketService from 'websocket/config';
import serverCall, { Token } from 'api/serverCall';
import KiteDisconnectConfirmation from 'components/alert/KiteDisconnectConfirmation';
import api from 'api/api';
import { dispatch } from 'store';
import { openSnackbar } from 'store/reducers/snackbar';
import { useStatusContext } from 'contexts/StatusContext';

// types
interface TabPanelProps {
  children?: ReactNode;
  dir?: string;
  index: number;
  value: number;
}

// tab panel wrapper
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
      sx={{ p: 1 }}
    >
      {value === index && children}
    </Box>
  );
}

// function a11yProps(index: number) {
//   return {
//     id: `profile-tab-${index}`,
//     'aria-controls': `profile-tabpanel-${index}`
//   };
// }

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

interface ProfilePageProps {
  setOrderRequestCount: (val: number) => void;
  orderRequestCount: number;
  setRecommendationRequestCount: (val: number) => void;
  recommendationRequestCount: number;
}

const ProfilePage = ({
  setOrderRequestCount,
  orderRequestCount,
  setRecommendationRequestCount,
  recommendationRequestCount
}: ProfilePageProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [openLogout, setOpenLogout] = useState<boolean>(false);
  const [openDisconnect, setOpenDisconnect] = useState<boolean>(false);
  const [openChangePassword, setOpenChangePassword] = useState<boolean>(false);
  const { setKiteStatus } = useStatusContext();

  const { logout, user } = useAuth();
  const handleLogout = async () => {
    try {
      await logout();
      WebSocketService.unsubscribeAll();
      Token.token = '';
      navigate(`/login`, {
        state: {
          from: ''
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleDisconnect = () => {
    const requestBody = {};
    serverCall.put(api.disconnectKite(), requestBody, (response: any, error: any) => {
      if (error) {
        console.error(error);
        const errorMessage = error?.response?.data.message as string;
        dispatch(
          openSnackbar({
            open: true,
            close: true,
            message: errorMessage || `Failed to Disconnect Kite`,
            variant: 'alert',
            alert: {
              color: 'error'
            },
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right'
            }
          })
        );
      } else {
        setOpenDisconnect(false);
        serverCall.get(api.checkServerHealth(), (response, error) => {
          if(!error){
            setKiteStatus(response.tickConnected);
          }
        });
        dispatch(
          openSnackbar({
            open: true,
            close: true,
            message: 'Successfully disconnected kite ',
            variant: 'alert',
            alert: {
              color: 'success'
            },
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right'
            }
          })
        );
      }
    });
  };

  const anchorRef = useRef<any>(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  //@ts-ignore
  const [value, setValue] = useState(0);

  // const handleChange = (event: SyntheticEvent, newValue: number) => {
  //   setValue(newValue);
  // };

  return (
    <>
      <ChangePasswordModal open={openChangePassword} handleClose={() => setOpenChangePassword(false)} />
      {openLogout && <LogoutConfirmationModal open={openLogout} handleClose={setOpenLogout} handleConfirm={handleLogout} />}
      {openDisconnect && (
        <KiteDisconnectConfirmation
          open={openDisconnect}
          handleClose={() => {
            setOpenDisconnect(false);
          }}
          handleConfirm={handleDisconnect}
        />
      )}
      <Box sx={{ flexShrink: 0, ml: 0.75 }}>
        <ButtonBase
          sx={{
            p: 0.25,
            borderRadius: 1,
            '&:hover': { bgcolor: theme.palette.mode === ThemeMode.DARK ? 'secondary.light' : 'secondary.lighter' },
            '&:focus-visible': {
              outline: `2px solid ${theme.palette.secondary.dark}`,
              outlineOffset: 2
            }
          }}
          aria-label="open profile"
          ref={anchorRef}
          aria-controls={open ? 'profile-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <Avatar alt="profile user" src={avatar1} />
        </ButtonBase>
        <Popper
          placement="bottom-end"
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          popperOptions={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 9]
                }
              }
            ]
          }}
        >
          {({ TransitionProps }) => (
            <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
              <Paper
                sx={{
                  boxShadow: theme.customShadows.z1,
                  width: 290,
                  minWidth: 240,
                  maxWidth: 290,
                  [theme.breakpoints.down('md')]: {
                    maxWidth: 250
                  },
                  borderRadius: 1.5
                }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <MainCard border={false} content={false}>
                    <CardContent sx={{ px: 2.5, pt: 3 }}>
                      <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item>
                          <Stack direction="row" spacing={1.25} alignItems="center">
                            <Avatar alt="profile user" src={avatar1} />
                            <Stack>
                              <Typography variant="subtitle1">{user?.firstName + ' ' + user?.lastName}</Typography>
                              <Typography variant="body2" color="secondary">
                                {user?.userType}
                              </Typography>
                            </Stack>
                          </Stack>
                        </Grid>
                        <Grid item>
                          <Tooltip title="Logout">
                            <IconButton
                              size="large"
                              color="error"
                              sx={{ p: 1 }}
                              onClick={() => {
                                setOpenLogout(true);
                              }}
                            >
                              <Logout variant="Bulk" />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </CardContent>
                    <Divider />
                    {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs variant="fullWidth" value={value} onChange={handleChange} aria-label="profile tabs">
                        <Tab
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textTransform: 'capitalize'
                          }}
                          icon={<Profile size={18} style={{ marginBottom: 0, marginRight: '10px' }} />}
                          label="Profile"
                          {...a11yProps(0)}
                        />
                        <Tab
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textTransform: 'capitalize'
                          }}
                          icon={<Setting2 size={18} style={{ marginBottom: 0, marginRight: '10px' }} />}
                          label="Setting"
                          {...a11yProps(1)}
                        />
                      </Tabs>
                    </Box> */}
                    <TabPanel value={value} index={0} dir={theme.direction}>
                      <ProfileTab
                        setOpenDisconnectModal={setOpenDisconnect}
                        setOpenChangePasswordModal={setOpenChangePassword}
                        setOpenLogoutModal={setOpenLogout}
                        setOrderRequestCount={setOrderRequestCount}
                        orderRequestCount={orderRequestCount}
                        setRecommendationRequestCount={setRecommendationRequestCount}
                        recommendationRequestCount={recommendationRequestCount}
                      />
                    </TabPanel>
                    {/* <TabPanel value={value} index={1} dir={theme.direction}>
                  <SettingTab />
                </TabPanel> */}
                  </MainCard>
                </ClickAwayListener>
              </Paper>
            </Transitions>
          )}
        </Popper>
      </Box>
    </>
  );
};

export default ProfilePage;
